export default "__VITE_ASSET__B$oJqXE1__"